/**
 * The main api service
 */
import http from '@util/http';
import { core } from '@api/req';

export async function queryGlobalConfigList(params) {
  return http.get(core.GET_GLOBAL_CONFIG_LIST, params);
}

export async function queryGlobalConfigConfig(params) {
  return http.get(core.GET_GLOBAL_CONFIG_CONFIG, params);
}

export async function queryGlobalConfigInfo(params) {
  return http.get(core.GET_GLOBAL_CONFIG_INFO, params);
}

export async function queryDeleteGlobalConfig(params) {
  return http.get(core.DELETE_GLOBAL_CONFIG, params);
}

export async function querySaveGlobalConfig(params) {
  return http.post(core.SAVE_GLOBAL_CONFIG, params);
}



// WEBPACK FOOTER //
// ./src/api/core/config.js